import React from 'react'
import Header from '../Header'

const Profile = () => {
  return (
    <div>
      <Header/>
    </div>
  )
}

export default Profile